import { Component, Vue } from 'vue-property-decorator';

import TrackingGuest from '../../../trackingGuest';
import template from './tmpl.vue';

@Component({
    components: {
        TrackingGuest,
    },
    mixins: [template],
})
class C extends Vue {
    trackingGuestOrderId: any = '';

    async mounted() {
        this.trackingGuestOrderId = this.$route.params.orderId;
    }
}

export default C;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/shipments-4-shippers-details/components/shipments/index.ts